import { useContext } from 'react';
import ModalContext from 'components/ui-kit/modal/context/modalContext';

const useModal = () => useContext(ModalContext);

export default useModal;
